/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Modal, Button, Form, OverlayTrigger, Tooltip, Badge, Alert, Pagination } from 'react-bootstrap';
import { FiSearch, FiTrash2, FiInfo, FiX, FiCheck, FiDownload, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const OrderInvoice = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const [companySettings, setCompanySettings] = useState(null);
  const [addresses, setAddresses] = useState([]);


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(5);

  // Safely get data from localStorage with fallbacks
  const userPermissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
  const canRead = userPermissions.includes('read_Order');
  const canEdit = userPermissions.includes('update_Order');
  const canDelete = userPermissions.includes('delete_Order');

  const userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
  const userAddresses = localStorage.getItem('addresses') ? JSON.parse(localStorage.getItem('addresses')) : [];
  const primaryAddress = userAddresses.length > 0 ? userAddresses[0] : {};

  // useEffect(() => {
  //   console.log("Logged-in User Data:", {
  //     userData,
  //     userAddresses,
  //     primaryAddress,
  //     userPermissions
  //   });
  // }, []);
  useEffect(() => {
    const fetchCompanySettings = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/api/settings`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const settingsArray = response.data;
        if (Array.isArray(settingsArray) && settingsArray.length > 0) {
          const settings = settingsArray[0];
          // console.log("✅ Company Settings:", settings);
          setCompanySettings(settings);
        } else {
          console.warn("⚠️ No settings found in the response.");
        }
      } catch (error) {
        console.error("❌ Error fetching settings:", error.response?.data || error.message);
      }
    };

    fetchCompanySettings();
  }, []);




  useEffect(() => {
    const fetchAddressData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/api/address`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // console.log("🌐 API Raw Response:", response);
        // console.log("📦 API Response Body:", response.data);

        const addressList = response.data;

        if (Array.isArray(addressList) && addressList.length > 0) {
          setAddresses(addressList);
          const lastAddress = addressList[addressList.length - 1];
          // console.log("✅ Last Address:", lastAddress);
        } else {
          console.log("⚠️ No addresses found.");
        }
      } catch (error) {
        console.error("❌ Error fetching address data:", error.response?.data || error.message);
      }
    };

    fetchAddressData();
  }, []);







  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await axios.get(`${API_BASE_URL}/api/orders`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        // Transform the data to handle MongoDB $oid and $numberInt formats
        const transformedOrders = res.data.data.map(order => ({
          ...order,
          _id: order._id?.$oid || order._id,
          userId: order.userId?.$oid || order.userId,
          buyerId: order.buyerId?.$oid || order.buyerId,
          price: order.price?.$numberInt ? parseInt(order.price.$numberInt) : order.price,
          quantity: order.quantity?.$numberInt ? parseInt(order.quantity.$numberInt) : order.quantity,
          total: order.total?.$numberInt ? parseInt(order.total.$numberInt) : order.total,
          createdAt: order.createdAt?.$date?.$numberLong ? new Date(parseInt(order.createdAt.$date.$numberLong)) : order.createdAt,
          updatedAt: order.updatedAt?.$date?.$numberLong ? new Date(parseInt(order.updatedAt.$date.$numberLong)) : order.updatedAt
        }));

        // Sort orders by createdAt in descending order (newest first)
        const sortedOrders = transformedOrders.sort((a, b) => {
          const dateA = new Date(a.createdAt || 0);
          const dateB = new Date(b.createdAt || 0);
          return dateB - dateA;
        });

        setOrders(sortedOrders);
        setFilteredOrders(sortedOrders);
        setCurrentPage(1); // Reset to first page when orders change
      }
    } catch (err) {
      console.error(err);
      setError('Failed to fetch orders. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Get current records for pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredOrders.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredOrders.length / recordsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deleteOrder = async (orderId) => {
    if (!canDelete) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_BASE_URL}/api/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const updated = orders.filter((o) => o._id !== orderId);
      setOrders(updated);
      setFilteredOrders(updated);
    } catch (err) {
      console.error(err);
      setError('Failed to delete order. Please try again.');
    }
  };

  const handleStatusChange = (order, isChecked) => {
    if (!canEdit) return;
    if (!isChecked) {
      setSelectedOrder(order);
      setShowModal(true);
    } else {
      updateOrderStatus(order._id, 'approved');
    }
  };

  const updateOrderStatus = async (orderId, status, reason = '') => {
    try {
      setError(null);
      const token = localStorage.getItem('token');
      await axios.patch(`${API_BASE_URL}/api/orders/${orderId}/status`, { status, rejectReason: reason }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const updated = orders.map((o) =>
        o._id === orderId ? { ...o, status, rejectReason: reason } : o
      );
      setOrders(updated);
      setFilteredOrders(updated);
      setShowModal(false);
      setSelectedOrder(null);
      setRejectionReason('');
    } catch (err) {
      console.error(err);
      setError('Failed to update order status. Please try again.');
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = orders.filter((o) =>
      o.productName.toLowerCase().includes(value) ||
      (o.fullName && o.fullName.toLowerCase().includes(value)) ||
      o.productCode.toLowerCase().includes(value)
    );
    setFilteredOrders(filtered);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handleRejectSubmit = () => {
    if (selectedOrder && rejectionReason.trim()) {
      updateOrderStatus(selectedOrder._id, 'rejected', rejectionReason);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'approved':
        return <Badge bg="success" className="py-2 px-1">Approved</Badge>;
      case 'rejected':
        return <Badge bg="danger" className="py-2 px-1">Rejected</Badge>;
      default:
        return <Badge bg="warning" text="dark" className="py-2 px-1">Pending</Badge>;
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = new Date(date);
    return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
  };



  const generateCompuGhostInvoice = (order) => {

    try {
      const orderAddress = addresses.find(
        addr => String(addr._id) === String(primaryAddress)
      );

      if (!orderAddress) {
        console.warn("⚠️ No matching address found for ID:", primaryAddress);
        return;
      }

      // console.log("🆔 primaryAddress ID:", primaryAddress);
      // console.log("✅ Matched Address Object:", orderAddress);

      const formattedAddress = `${orderAddress.address1 || ''}, ${orderAddress.city?.name || 'N/A'}, ${orderAddress.state?.name || 'N/A'}, ${orderAddress.country?.name || 'N/A'}, ${orderAddress.pincode || 'N/A'}`;

      let phoneNumbers = 'N/A';

      if (orderAddress?.phoneNumber1 || orderAddress?.phoneNumber2) {
        if (orderAddress.phoneNumber1 === orderAddress.phoneNumber2) {
          phoneNumbers = orderAddress.phoneNumber1 || 'N/A';
        } else {
          phoneNumbers = `${orderAddress.phoneNumber1 || ''}${orderAddress.phoneNumber2 ? `, ${orderAddress.phoneNumber2}` : ''}`;
        }
      }
      const getStatusColor = (status) => {
        if (!status) return '#808080'; // gray for undefined
        const lowerStatus = status.toLowerCase();
        switch (lowerStatus) {
          case 'rejected':
            return '#dc3545'; // red
          case 'approved':
            return '#28a745'; // green
          case 'pending':
            return '#ffc107'; // yellow/orange
          default:
            return '#808080'; // gray
        }
      };

      const statusColor = getStatusColor(order.status);
      const statusText = order.status ? order.status.charAt(0).toUpperCase() + order.status.slice(1).toLowerCase() : 'N/A';

      //   console.log("🧾 Formatted Address:", formattedAddress);
      //   console.log("📱 phoneNumber1:", orderAddress.phoneNumber1);
      // console.log("📱 phoneNumber2:", orderAddress.phoneNumber2);
      // console.log("📞 Phone Numbers:", phoneNumbers);
      // Create a new HTML document for the invoice
      const invoiceHTML = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title> ${order.productName || 'CompuGhost'}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              color: #000;
            }
            .invoice-container {
              max-width: 900px;
              margin: 0 auto;
              border: 1px solid black;
            }
            .header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              padding: 15px 20px;
              border-bottom: 1px solid #000;
              background: #f9f9f9;
            }
            .logo-section {
              display: flex;
              align-items: center;
              gap: 10px;
            }
            .logo-section img {
              max-height: 50px;
            }
            .logo-text {
              font-size: 22px;
              font-weight: 700;
              color: #1a75bb;
              line-height: 1.1;
            }
            .logo-text small {
              font-weight: 400;
              font-size: 14px;
              display: block;
              color: #333;
              margin-top: 2px;
            }
            .tax-info {
              text-align: right;
              font-weight: 700;
              font-size: 12px;
              line-height: 1.4;
              white-space: nowrap;
            }
            .tax-info span {
              display: block;
              font-weight: 700;
            }
            .contact-info {
              padding: 10px 20px;
              font-size: 12px;
              font-weight: 600;
              background: #eee;
              border-bottom: 1px solid #000;
            }
            .contact-info p {
              margin: 2px 0;
              font-weight: 600;
              line-height: 1.3;
            }
            .contact-info a {
              color: #1155cc;
              text-decoration: none;
              font-weight: 600;
            }
            .invoice-sections {
              display: flex;
              justify-content: space-between;
              padding: 20px;
              font-size: 12px;
              font-weight: 600;
            }
            .invoice-sections div {
              max-width: 48%;
            }
            .section-title {
              font-weight: 700;
              margin-bottom: 8px;
              border-bottom: 1px solid #000;
              padding-bottom: 3px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 12px;
              font-weight: 600;
            }
            table thead tr {
              background: #ddd;
              font-weight: 700;
            }
            table, th, td {
              border: 1px solid #000;
              padding: 7px 8px;
              text-align: center;
              vertical-align: middle;
            }
            th {
              text-align: center;
            }
            td.left-align {
              text-align: left;
              padding-left: 8px;
            }
            .notes-row td {
              text-align: left;
              font-weight: 600;
              padding: 10px 8px;
              min-height: 40px;
            }
            .footer-section {
              display: flex;
              justify-content: space-between;
              padding: 30px 20px 15px 20px;
              font-size: 12px;
              font-weight: 600;
              min-height: 100px;
            }
            .footer-section div {
              width: 45%;
              border: 1px solid #000;
              padding: 15px 10px;
              box-sizing: border-box;
            }
            .footer-bottom {
              text-align: center;
              font-size: 11px;
              font-weight: 600;
              border-top: 1px solid #000;
              padding: 8px 0;
              background: #f9f9f9;
            }
            @media screen and (max-width: 650px) {
              .invoice-sections {
                flex-direction: column;
              }
              .invoice-sections > div {
                max-width: 100%;
                margin-bottom: 15px;
              }
              .footer-section {
                flex-direction: column;
              }
              .footer-section > div {
                width: 100%;
                margin-bottom: 15px;
              }
            }
          </style>
        </head>
        <body>
          <div class="invoice-container" role="main" aria-label="Tax Invoice">
         <header class="header">
            <div class="logo-section">
                <img 
                 src="${API_BASE_URL}/uploads/${companySettings?.companyLogo || 'default-logo.png'}" 
                 alt="${companySettings?.companyName || 'CompuGhost'} company logo" 
                onerror="this.onerror=null;this.src='https://via.placeholder.com/50x50?text=CG';"
              />
    
            </div>
            <div class="tax-info" aria-label="Tax Invoice details">
            <div><strong>TAX INVOICE</strong></div>
            <div>GST ID: 24AAACH7409R2Z1</div>
            <div>PAN No: DFHOI4564F</div>
          </header>

          <section class="contact-info" aria-label="Company Contact Information">
            <p><strong>Address:</strong> ${companySettings?.address || 'N/A'}</p>
            <p><strong>e-Mail :</strong> <a href="mailto:${userData.email}"> ${companySettings?.email || 'N/A'}</a></p>
            <p><strong>Contact No. :</strong>  ${companySettings?.contactNumber || 'N/A'}</p>
            <p><strong>Web Site:</strong> <a href="${companySettings?.website || '#'}" target="_blank" rel="noopener">${companySettings?.website || 'https://www.compughost.com'}</a></p>
          </section>

            <section class="invoice-sections">
              <div aria-label="Buyer Details">
                <div class="section-title">To,</div>
                <p><strong>Buyer E-Mail :</strong> ${order.buyerName || order.userId?.email || order.userId?._id || 'morhnen23@gmail.com'}</p>
                <p><strong>Customer Name :</strong> ${order.fullName || 'ccs buyer'}</p>
                <p><strong>Address :</strong> ${order.address || '10, nakshatra height & gopal chowk, india, Gujarat, Rajkot'}</p>
                <p><strong>Contact No. :</strong> ${order.phoneNumber || '9876543200'}</p>
              <p>
                <strong>Status :</strong>
                <span style="
                  padding: 4px 8px;
                  border-radius: 4px;
                  color: white;
                  background-color: ${statusColor};
                ">
                  ${statusText}
                </span>
              </p>
                
             
              </div>

              <div aria-label="Seller & Invoice Details">
                <div class="section-title">From,</div>
                 <p><strong>Invoice No. :</strong> ${order._id}</p>
                 <p><strong>Invoice Date :</strong> ${order.createdAt ? new Date(order.createdAt).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}</p>
                 <p><strong>Seller Name :</strong> ${userData.name || 'N/A'}</p>
                 <p><strong>Address :</strong> ${formattedAddress}</p>
                 <p><strong>Contact No. :</strong> ${phoneNumbers}</p>
                 <p><strong>E-Mail :</strong> ${userData.email || 'N/A'}</p>
        
                </div>
            </section>

            <table aria-label="Invoice Item Details">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Name</th>
                  <th>Code</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Base Total</th>
                  <th>Taxes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td class="left-align">${order.productName || 'seller 1 product'}</td>
                  <td>${order.productCode || 'SPP'}</td>
                  <td>${order.quantity || '250'}</td>
                  <td>₹${order.price?.toLocaleString('en-IN') || '500.00'}</td>
                  <td>₹${(order.price * order.quantity)?.toLocaleString('en-IN') || '125000.00'}</td>
                  <td>₹${(order.price * order.quantity * 0)?.toLocaleString('en-IN') || '22500.00'}</td>
                </tr>
                <tr class="notes-row">
                  <td colspan="2" class="left-align"><strong>Notes</strong></td>
                  <td colspan="5" style="color: red;"><strong>${order.rejectReason || ''}</strong></td>
                </tr>
                <tr>
                  <td colspan="5" class="left-align" style="font-weight:700;">Total</td>
                  <td>₹${(order.price * order.quantity)?.toLocaleString('en-IN') || '125000.00'}</td>
                  <td>₹${(order.price * order.quantity * 0)?.toLocaleString('en-IN') || '22500.00'}</td>
                </tr>
                <tr>
                  <td colspan="5" class="left-align" style="font-weight:700;">Invoice Total</td>
                  <td colspan="2" style="font-weight:700;">₹${(order.price * order.quantity)?.toLocaleString('en-IN') || '147500.00'}</td>
                </tr>
              </tbody>
            </table>

            <section class="footer-section">
              <div aria-label="Receiver signature and seal area" role="textbox" tabindex="0">
                Receiver's Signature & Seal
              </div>
              <div aria-label="For signature by ICART" role="textbox" tabindex="0">
                For;BROCHURE
              </div>
            </section>

            <section class="footer-bottom" aria-label="Invoice Generation Note">
              Computer generated invoice. It does not require signature.
            </section>
          </div>
        </body>
        </html>
      `;

      // Create a new window with the invoice HTML
      const win = window.open('', '_blank');
      win.document.write(invoiceHTML);
      win.document.close();

      // After the content is loaded, print the invoice
      win.onload = function () {
        setTimeout(() => {
          win.print();
        }, 500);
      };

    } catch (err) {
      console.error('Error generating invoice:', err);
      setError('Failed to generate invoice. Please try again.');
    }
  };

  useEffect(() => {
    if (canRead) {
      fetchOrders();
    } else {
      setLoading(false);
    }
  }, []);

  if (!canRead) {
    return (
      <div className="container mt-5">
        <Alert variant="danger" className="text-center">
          <h4>Access Denied</h4>
          <p>You do not have permission to view orders.</p>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white border-0 pt-4 pb-3">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0 text-primary">
              <strong>Order Management</strong>
            </h3>
            <div className="position-relative w-50">
              <div className="position-absolute start-0 top-50 translate-middle-y ms-3">
                <FiSearch className="text-muted" />
              </div>
              <input
                type="text"
                className="form-control ps-5"
                placeholder="Search by product, buyer or code..."
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>

        <div className="card-body px-0 py-2">
          {error && (
            <Alert variant="danger" onClose={() => setError(null)} dismissible className="mx-3">
              {error}
            </Alert>
          )}

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading orders...</p>
            </div>
          ) : filteredOrders.length === 0 ? (
            <div className="text-center py-5">
              <img
                src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
                alt="No orders"
                style={{ width: '120px', opacity: 0.6 }}
                className="mb-3"
              />
              <h5 className="text-muted">No orders found</h5>
              <p className="text-muted">Try adjusting your search or check back later</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '4%' }}>id</th>
                      <th style={{ width: '9%' }}>Image</th>
                      <th style={{ width: '9%' }}>Order ID</th>
                      <th style={{ width: '14%' }}>Product</th>
                      <th style={{ width: '10%' }}>Code</th>
                      <th style={{ width: '10%' }}>Buyer</th>
                      <th style={{ width: '8%' }}>Price (₹)</th>
                      <th style={{ width: '5%' }}>Qty</th>
                      <th style={{ width: '10%' }}>Total (₹)</th>
                      <th style={{ width: '10%' }}>Status</th>
                      <th style={{ width: '10%' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.map((order, index) => (
                      <tr key={order._id} className={order.status === 'rejected' ? 'bg-light' : ''}>
                        <td className="text-muted">{indexOfFirstRecord + index + 1}</td>
                        <td>
                          <div className="rounded" style={{ width: '60px', height: '60px', overflow: 'hidden' }}>
                            <img
                              src={order.image || 'https://via.placeholder.com/60'}
                              alt={order.productName}
                              className="img-fluid h-100 w-100 object-fit-cover"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/60';
                              }}
                            />
                          </div>
                        </td>
                        <td>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Order ID: {order._id}</Tooltip>}
                          >
                            <span className="text-primary fw-bold" style={{ cursor: 'pointer' }} onClick={() => generateCompuGhostInvoice(order)}>
                              #{order._id.slice(-6).toUpperCase()}
                            </span>
                          </OverlayTrigger>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="fw-medium text-truncate" style={{ maxWidth: '150px' }}>
                              {order.productName}
                            </span>
                            <small className="text-muted">Created: {formatDate(order.createdAt)}</small>
                          </div>
                        </td>
                        <td>
                          <Badge bg="light" text="dark" className="border">
                            {order.productCode}
                          </Badge>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="text-truncate" style={{ maxWidth: '120px' }}>
                              {order.buyerName || order.userId?.email || order.userId?._id}
                            </span>
                          </div>
                        </td>
                        <td className="fw-medium">₹{order.price?.toLocaleString('en-IN')}</td>
                        <td>{order.quantity}</td>
                        <td className="fw-bold text-primary">₹{order.total?.toLocaleString('en-IN')}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {getStatusBadge(order.status)}
                            {order.status === 'rejected' && order.rejectReason && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>
                                    <strong>Reason:</strong> {order.rejectReason}
                                  </Tooltip>
                                }
                              >
                                <span className="ms-2">
                                  <FiInfo className="text-danger" />
                                </span>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="d-flex gap-2">
                            {canEdit && (
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={order.status === 'approved'}
                                  onChange={(e) => handleStatusChange(order, e.target.checked)}
                                  disabled={!canEdit}
                                  style={{ width: '3em', height: '1.5em' }}
                                />
                              </div>
                            )}
                            {canDelete && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => deleteOrder(order._id)}
                                className="d-flex align-items-center"
                              >
                                <FiTrash2 size={16} />
                              </Button>
                            )}
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => generateCompuGhostInvoice(order)}
                              className="d-flex align-items-center"
                            >
                              <FiDownload size={16} />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {filteredOrders.length > recordsPerPage && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <FiChevronLeft />
                    </Pagination.Prev>

                    {[...Array(totalPages)].map((_, index) => (
                      <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}

                    <Pagination.Next
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <FiChevronRight />
                    </Pagination.Next>
                  </Pagination>
                </div>
              )}
            </>
          )}
        </div>

        {filteredOrders.length > 0 && (
          <div className="card-footer bg-white border-0 py-3">
            <div className="d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Showing {indexOfFirstRecord + 1} to {Math.min(indexOfLastRecord, filteredOrders.length)} of {filteredOrders.length} orders
              </small>
              <Button variant="outline-primary" size="sm" onClick={fetchOrders}>
                Refresh Orders
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Rejection Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-danger">Reject Order</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-1">
          {selectedOrder && (
            <>
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="me-3">
                    <img
                      src={selectedOrder.image || 'https://via.placeholder.com/60'}
                      alt={selectedOrder.productName}
                      className="rounded"
                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                    />
                  </div>
                  <div>
                    <h6 className="mb-1">{selectedOrder.productName}</h6>
                    <div className="d-flex gap-3">
                      <small className="text-muted">Order: #{selectedOrder._id.slice(-6).toUpperCase()}</small>
                      <small className="text-muted">Code: {selectedOrder.productCode}</small>
                    </div>
                  </div>
                </div>
                <div className="bg-light p-3 rounded">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Quantity:</span>
                    <span className="fw-medium">{selectedOrder.quantity}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Total Amount:</span>
                    <span className="fw-bold text-primary">₹{selectedOrder.total?.toLocaleString('en-IN')}</span>
                  </div>
                </div>
              </div>
              <Form.Group>
                <Form.Label className="fw-medium">Reason for Rejection</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Please specify the reason for rejecting this order..."
                  className="border-2"
                />
                <Form.Text className="text-muted">
                  This will be visible to the buyer.
                </Form.Text>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
            <FiX className="me-1" /> Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleRejectSubmit}
            disabled={!rejectionReason.trim()}
          >
            <FiCheck className="me-1" /> Confirm Rejection
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderInvoice;